export default __webpack_public_path__ + "static/media/Main.cd26768b.png";